import React from 'react';
import { Box } from '../box';
import { Stack } from '../stack';
import { WithUpperlineProps } from './model';
export type { WithUpperlineProps } from './model';

export const WithUpperline: React.FC<React.PropsWithChildren<WithUpperlineProps>> = (props) => {
  const { children, sx, color = 'primary' } = props;
  return (
    <Stack direction="row" sx={{ position: 'relative', ...sx }}>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: { xs: 40, md: 80 },
          height: 2,
          backgroundColor: color === 'white' ? 'white' : 'brand gray',
        }}
      />
      <Stack direction="row" pt={{ xs: 1, md: 2 }} sx={{ textIndent: { xs: 8, md: 16 } }}>
        {children}
      </Stack>
    </Stack>
  );
};
